// Paso "Tus datos" de los partidos abiertos: sumarse a uno (OpenMatchDetail, sin login) y crear uno (T10/T17,
// dentro del shell de la reserva). Los campos son los mismos de la reserva de cancha: viven en
// `BuyerDataFields` (nombre y apellido, email, teléfono con país, DNI), más el opt-in de novedades
// (MarketingOptIn) y la aceptación de las reglas.
// - `variant`: "mobile" (default, clases `rmob-field`) o "desktop" (`.fgrid` de dos columnas del checkout).
// - `compact`: tipografía/espaciado reducidos para que el paso entre en una pantalla sin scroll.
// - `hideActions` + `formId`: el shell dibuja los botones (barra fija en mobile) y envía con `form={formId}`.
// - `defaults`: usuario logueado (`auth.user`); nombre, email, DNI y teléfono (solo si es válido) se precargan
//   y siguen siendo editables. Un invitado entra con todo vacío.
// No llama a la API: devuelve los valores ya validados por `onSubmit(values, country, marketingOptIn)`.
import React, { useState } from "react";
import { Alert } from "react-bootstrap";
import { useForm } from "react-hook-form";
import RIcon from "../../reservas/components/ReservasIcons";
import MarketingOptIn from "../../reservas/components/MarketingOptIn";
import BuyerDataFields, { splitPhone } from "./BuyerDataFields";
import "../../reservas/reservas-mobile.css";
import "./OpenMatchCompact.css";

// `submitLabel`/`submittingLabel`/`consentRules` cambian solo los textos ("Publicar partido", reglas del que
// organiza); los campos son los mismos.
const OpenMatchJoinForm = ({
	clubName,
	defaults = {},
	submitting,
	error,
	onSubmit,
	onCancel,
	submitLabel = "Confirmar y sumarme",
	submittingLabel = "Sumándote…",
	consentRules = "pagás tu parte en el club y podés bajarte hasta la hora de cierre.",
	variant = "mobile",
	compact = false,
	formId,
	hideActions = false,
	title = "Tus datos",
}) => {
	const desktop = variant === "desktop";
	const initialPhone = splitPhone(defaults.phone || defaults.phoneNumber);
	const [country, setCountry] = useState(initialPhone.country);
	const [marketingOptIn, setMarketingOptIn] = useState(false);
	const [consent, setConsent] = useState(true);
	const [consentMissing, setConsentMissing] = useState(false);
	const {
		register,
		handleSubmit,
		trigger,
		formState: { errors },
	} = useForm({
		mode: "onChange",
		defaultValues: { name: defaults.name || "", email: defaults.email || "", phone: initialPhone.phone, dni: defaults.dni || "" },
	});

	const submit = handleSubmit((values) => {
		if (!consent) {
			setConsentMissing(true);
			return;
		}
		onSubmit(values, country, marketingOptIn);
	});

	return (
		<form id={formId} className={`open-match-join-form${compact ? " oma-compact" : ""}`} onSubmit={submit}>
			{title && <h2 style={{ fontSize: compact ? 18 : 22, fontWeight: 800 }}>{title}</h2>}

			{desktop ? (
				<div className="fgrid">
					<BuyerDataFields register={register} errors={errors} trigger={trigger} country={country} onCountryChange={setCountry} />
				</div>
			) : (
				<BuyerDataFields variant="mobile" register={register} errors={errors} trigger={trigger} country={country} onCountryChange={setCountry} />
			)}

			<MarketingOptIn venueName={clubName} checked={marketingOptIn} onChange={setMarketingOptIn} />
			<div className="consent" onClick={() => { setConsent((c) => !c); setConsentMissing(false); }}>
				<span className={`cbox${consent ? " on" : ""}`}>{consent && <RIcon name="check" width={13} height={13} />}</span>
				<p>Acepto las <strong>reglas del partido</strong>: {consentRules}</p>
			</div>
			{consentMissing && <span className="rmob-field-error">Aceptá las reglas del partido para continuar.</span>}

			{error && <Alert variant="danger" className="mt-3">{error}</Alert>}

			{!hideActions && (
				<div style={{ display: "flex", gap: 10, marginTop: compact ? 12 : 16 }}>
					<button type="button" className="r-btn-soft" onClick={onCancel} disabled={submitting}>Volver</button>
					<button type="submit" className="r-btn-primary" disabled={submitting || !consent} style={{ flex: 1 }}>
						{submitting ? submittingLabel : submitLabel}
					</button>
				</div>
			)}
		</form>
	);
};

export default OpenMatchJoinForm;
